/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalSeedCategoryNotificationSettings} from '../api'

export const useMutationInternalSeedCategoryNotificationSettings = createReactQueryMutationHook('internalSeedCategoryNotificationSettings', internalSeedCategoryNotificationSettings)
